export default "__VITE_ASSET__g6SVig5F__"